module.exports = __webpack_public_path__ + "static/media/icon-w-obregon.01bf0df6.png";